import { all, takeEvery, put } from 'redux-saga/effects';
import * as notifications from 'react-notification-system-redux';

let subscriptions = [];

const defaultConfig = {
    position: 'br',
    autoDismiss: 5,
    dismissible: 'button',
    action: null,
    children: null,
    onAdd: null,
    onRemove: null,
    uid: null
};

const getSubscription = (action) => subscriptions.find((s) => action.type === s.actionType);

export function* dispatchNotification(action) {
    const subscription = getSubscription(action);

    const { config = {} } = subscription;

    yield put(notifications.show(
        {
            title: action.title,
            message: action.message,
            ...defaultConfig,
            ...config
        },
        config.level || 'error'
    ));
}

export const subscribe = (actionType, config) => subscriptions.push({ actionType, config });

export const unsubscribe = (actionType) => {
    subscriptions = subscriptions.filter((s) => s.actionType !== actionType);
};

export const clearSubscriptions = () => {
    subscriptions = [];
};

export default function* rootSaga() {
    yield all([
        takeEvery(getSubscription, dispatchNotification)
    ]);
}
